import { ServiceData } from '@/types';

import articles from './ASTROLOGY_ARTICLES_HR.json';
import audios from './ASTROLOGY_AUDIOS_HR.json';

export const ASTROLOGY_DATA_HR: ServiceData = {
  articles,
  audios,
};
